<template>
  <div class="record-list main-content">
    <div class="filter-content">
      <div class="time-content">
        <el-col :span="7">
          <el-select v-model="timeType" placeholder="选择时间类型" style="width: 100%;">
            <el-option label="录入时间" :value="5"></el-option>
            <el-option label="报告时间" :value="10"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-date-picker type="date" placeholder="开始日期" value-format="timestamp"
                          :picker-options="pickerOptionStart"
                          v-model="startTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="1">至</el-col>
        <el-col :span="8">
          <el-date-picker type="date" placeholder="结束日期" value-format="timestamp"
                          :picker-options="pickerOptionEnd"
                          v-model="endTime" style="width: 100%;"></el-date-picker>
        </el-col>
      </div>
      <el-button type="primary" class="search-btn" @click="searchHandle" :disabled="loading">
        <i class="fas fa-search"></i>
        搜索
      </el-button>
      <div class="action-buttons">
        <el-button class="search-btn export-btn" @click="getDownloadUrl" :disabled="download_dis">
          <i class="fas fa-download"></i>
          批量下载报告
        </el-button>
        <el-button class="search-btn export-btn" @click="exportClick" :disabled="export_dis">
          <i class="fas fa-file-excel"></i>
          导出订单信息
        </el-button>
      </div>
    </div>
    <div class="soft-card table-soft-wrapper">
      <el-table
        :data="listData"
        v-loading="loading"
        @selection-change="selectHandle"
        class="soft-el-table"
        header-row-class-name="soft-table-header"
        row-class-name="soft-table-row"
        style="width: 100%;"
        border>
        <el-table-column
          type="selection"
          width="50"
          :selectable="selectInit"
          fixed="left">
        </el-table-column>
        <!-- 移动端：客户姓名放在第一列 -->
        <el-table-column
          v-if="isMobile"
          prop="customerName"
          label="客户姓名"
          width="120"
          fixed="left">
          <template slot="header" slot-scope="scope">
            <el-input @keyup.enter.native="searchHandle" v-model="user_name_search" placeholder="客户姓名" clearable
                      size="mini">
              <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectName"
          width="160"
          label="项目名称"
          fixed="left"
          show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input @keyup.enter.native="searchHandle" v-model="proj_name_search" placeholder="项目名称" clearable
                      size="mini">
              <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
            </el-input>
          </template>
        </el-table-column>
        <!-- PC端：客户姓名在项目名称之后 -->
        <el-table-column
          v-if="!isMobile"
          prop="customerName"
          label="客户姓名"
          width="120"
          fixed="left">
          <template slot="header" slot-scope="scope">
            <el-input @keyup.enter.native="searchHandle" v-model="user_name_search" placeholder="客户姓名" clearable
                      size="mini">
              <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerGender"
          width="60"
          label="性别">
        </el-table-column>
        <el-table-column
          width="60"
          prop="customerAge"
          label="年龄">
        </el-table-column>
        <el-table-column width="120" align="center">
          <template slot="header" slot-scope="scope">
            <el-select
              popper-class="filter_options"
              v-model.number="dataStatus"
              size="mini"
              placeholder="订单状态"
              @change="searchHandle"
            >
              <el-option
                v-for="opt in orderStateOptions"
                :key="opt.value"
                :label="opt.name"
                :value="opt.value"
                :style="{ '--bgcolor': (opt.attr && opt.attr.color) ? opt.attr.color : '#ffffff' }"
              />
            </el-select>
          </template>
          <template slot-scope="scope">
            <div v-for="opt in orderStateOptions" :key="opt.value">
              <p
                v-if="scope.row.status === opt.value"
                :style="{ backgroundColor: opt.attr && opt.attr.color ? opt.attr.color : '#ffffff' }"
                class="status-btn"
              >
                {{ opt.name }}
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="level"
          width="120"
          label="报告级别"
          align="center">
          <template slot="header" slot-scope="scope">
            <el-select popper-class="filter_options" v-model="rpt_level_select" placeholder="报告级别" size="mini"
                       @change="searchHandle">
              <el-option
                v-for="item in rpt_level_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :style="{ '--bgcolor': (item.attr && item.attr.color) ? item.attr.color : '#ffffff' }">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <div v-if="getRptLevelItem(scope.row.level)"
                 :style="'background:' + ((getRptLevelItem(scope.row.level).attr && getRptLevelItem(scope.row.level).attr.color) || getRptLevelItem(scope.row.level).color || '') + ';'" class="status-btn">
              {{ getRptLevelItem(scope.row.level).name }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="160"
          prop="receiveTime"
          label="录入时间">
          <template slot-scope="scope">
            <div v-if="scope.row.receiveTime != 0 && scope.row.receiveTime != null">
              {{ scope.row.receiveTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerMobile"
          label="手机号码"
          width="120">
        </el-table-column>
        <el-table-column
          prop="checkCode"
          width="180"
          label="识别码">
        </el-table-column>
        <el-table-column
          width="160"
          prop="reportTime"
          label="报告时间">
          <template slot-scope="scope">
            <div v-if="scope.row.reportTime != 0 && scope.row.reportTime != null">
              {{ scope.row.reportTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="checkupCode"
          label="客户编码"
          width="240">
          <template slot="header" slot-scope="scope">
            <el-input @keyup.enter.native="searchHandle" v-model="exam_code_search" placeholder="客户编码" clearable
                      size="mini">
              <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          label="操作"
          fixed="right">
          <template slot-scope="scope">
            <el-button class="action-btn action-btn-success"
                       @click="downloadReportHandle(scope.row)" v-if="scope.row.status === 400">
              <i class="fas fa-download"></i>
              下载报告
            </el-button>
            <el-button v-if="scope.row.status == 0" @click="showEditDiaHandle(scope.row)" class="action-btn">
              <i class="fas fa-edit"></i>
              编辑
            </el-button>
            <el-button v-if="scope.row.status == 0" @click="delHandle(scope.row)" class="action-btn action-btn-danger">
              <i class="fas fa-trash-alt"></i>
              删除
            </el-button>
            <el-button v-if="scope.row.status == 5000" @click="showReasonDiaHandle(scope.row)" class="action-btn action-btn-danger">
              <i class="fas fa-info-circle"></i>
              驳回日志
            </el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="no-data">
            当前暂无数据
          </div>
        </template>
      </el-table>
      <pagination
        :total="page_total"
        :current-page="current_page"
        :page-size="page_limit"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </pagination>
    </div>

    <el-dialog
      title="编辑订单信息"
      :visible.sync="isShowEditDia"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="form-dialog"
      show-close>
      <div>
        <p class="mess">项目名称<span>{{ orderForm.projName }}</span></p>
        <el-form ref="orderForm" :rules="orderFromRules" :model="orderForm" label-width="80px">
          <el-form-item label="客户姓名" prop="csrName">
            <el-input v-model="orderForm.csrName"></el-input>
          </el-form-item>
          <el-form-item label="客户性别" prop="csrGender">
            <el-radio-group v-model="orderForm.csrGender">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="客户年龄" prop="csrAge">
            <el-input-number v-model="orderForm.csrAge" :min="1" :max="150"></el-input-number>
          </el-form-item>
          <el-form-item label="手机号码" prop="csrMobile">
            <el-input v-model="orderForm.csrMobile"></el-input>
          </el-form-item>
          <el-form-item label="识别码">
            <el-input v-model="orderForm.checkCode"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowEditDia = false">取 消</el-button>
        <el-button type="primary" @click="updateOrderHandle('orderForm')" :disabled="updating">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="驳回日志"
      :visible.sync="isShowReasonDia"
      width="560px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="form-dialog"
      show-close>
      <el-table
        :data="oprData"
        v-loading="oprLoading"
        class="soft-el-table back-table"
        header-row-class-name="soft-table-header"
        row-class-name="soft-table-row"
        style="width: 100%;"
        border>
        <el-table-column
          width="160"
          prop="backTime"
          label="驳回时间">
          <template slot-scope="scope">
            <div v-if="scope.row.backTime != 0 && scope.row.backTime != null">
              {{ scope.row.backTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="backReason"
          label="驳回原因">
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import ApiService from "../service/ApiService";
import pub from "../service/public";
import Pagination from './Pagination.vue'

export default {
  name: "recordList",
  components: {
    Pagination
  },
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      isMobile: false,
      timeType:5,
      startTime: '',  // 录入时间
      endTime: '',
      pickerOptionStart: {
        disabledDate: time => {
          if (this.endTime) {
            return time.getTime() > new Date(this.endTime).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionEnd: {
        disabledDate: time => {
          if (this.startTime) {
            return time.getTime() < new Date(this.startTime).getTime() || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      listData: [],
      loading: false,
      page_total: 0,
      current_page: 1,
      page_sizes: [10, 20, 50, 100],
      page_limit: 10, // 每页多少条
      proj_name_search: '',
      user_name_search: '',
      exam_code_search: '',
      dataStatus: -1,
      orderStateOptions: [],
      rpt_level_select: -1,
      rpt_level_options: [],
      download_dis: false,
      export_dis: false,
      batch_list: {
        orderUuid: [],
        checkupCode: []
      },
      isShowEditDia: false,
      orderForm: {},
      orderFromRules: {
        csrName: [
          {required: true, message: '请输入客户姓名', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
        ],
        csrGender: [
          {required: true, message: '请选择客户性别', trigger: 'change'}
        ],
        csrAge: [
          {required: true, message: '请输入客户年龄', trigger: 'blur'}
        ],
        csrMobile: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
      },
      isShowReasonDia:false,
      oprData:[],
      oprLoading:false,
      updating: false,
      deleting: false,
      downloading: false
    }
  },
  created() {
    this.initConstOptions();
    this.initData();
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    // 检测是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    buildTimeFrameParams() {
      let startTime = this.startTime ? this.startTime / 1000 : 0;
      let endTime = this.endTime ? this.endTime / 1000 : 0;

      // 改为返回时间条件数组，可同时传多个时间段
      const timeFrames = [];

      // 录入时间
      if (startTime || endTime) {
        timeFrames.push({
          timeType: Number(this.timeType),
          startTime: startTime,
          endTime: endTime,
        });
      }

      return timeFrames;
    },

    // 构建查询参数
    buildQueryParams() {
      const timeFrame = this.buildTimeFrameParams();

      return {
        page: {
          number: this.current_page - 1,
          limit: this.page_limit
        },
        keyWord: [],
        parms: {
          // 时间查询改为数组
          timeFrame: timeFrame,
          projectName: this.proj_name_search,
          customerName: this.user_name_search,
          checkupCode: this.exam_code_search,
          level: this.rpt_level_select,
          status: this.dataStatus
        }
      };
    },

    // 统一错误处理
    handleError(error, context = '') {
      this.loading = false;
      const message = (error && error.response && error.response.data && error.response.data.message) ||
        (error && error.message) ||
        '请求失败';

        console.log(message)
    },

    indexHandle(index) {
      index = (index + 1) + (this.current_page - 1) * this.page_limit;
      return index
    },

    pageChange(item) {
      this.current_page = item.current_page;
      if (item.type == 'size') {
        this.page_limit = item.page_limit;
      }
      this.initData(); //改变页码，重新渲染页面
    },

    handleSizeChange(size) {
      this.page_limit = size;
      this.current_page = 1;
      this.initData();
    },

    handleCurrentChange(page) {
      this.current_page = page;
      this.initData();
    },

    selectInit(row) {
      return row.status === 400 ? 1 : 0;
    },

    initData() {
      if (this.loading) return;
      this.loading = true;
      this.listData = [];

      const params = this.buildQueryParams();

      ApiService.HeartRecordList(params).then(res => {
        this.loading = false;
        if (res.code === pub.backCode.SUCCESS) {
          this.listData = res.data.pageList;
          if (this.current_page == 1) {
            this.page_total = res.data.itemTotal;
          }
        } else {
          pub.analysisReturnCode(res, this.initData);
        }
      }).catch(error => {
        this.handleError(error, '记录列表');
      });
    },
    // 搜索
    searchHandle() {
      this.current_page = 1;
      this.initData();
    },
    // 下载报告
    downloadReportHandle(val) {
      if (this.downloading) return;
      // 直接使用列表返回的 PDF 报告地址
      if (val.mergeReportFileName) {
        this.downloading = true;
        const fileName = `报告_${val.customerName}(${val.customerGender})`;
        pub.fileLinkToStreamDownload(val.mergeReportFileName, fileName, 'pdf');
        setTimeout(() => { this.downloading = false; }, 2000);
      } else {
        pub.tip('该记录暂无报告，请联系相关人员', 'warning');
      }
    },

    // 初始化枚举选项
    initConstOptions() {
      let constData = pub.getConst();
      if (constData) {
        // 订单状态
        let orderState = [
          {
            name: '订单状态',
            value: -1
          }
        ]
        this.orderStateOptions = (constData.orderState || []).map(opt => ({
          ...opt,
          value: Number(opt.value)
        }));
        this.orderStateOptions = orderState.concat(this.orderStateOptions);
        // 报告级别
        if (constData.rptLevel) {
          this.rpt_level_options = [{value: -1, label: '报告级别'}].concat(
            constData.rptLevel.heart.map(item => ({value: item.value, label: item.name, attr: item.attr}))
          );
        }
      }
    },
    // 获取报告级别枚举项
    getRptLevelItem(value) {
      const constData = pub.getConst();
      if (!constData || !constData.rptLevel || !constData.rptLevel.heart) {
        return null;
      }
      return constData.rptLevel.heart.find(item => item.value == value) || null;
    },
    // 获取选中的内容
    selectHandle(val) {
      let orderUuid = [];
      let checkupCode = []
      for (let i = 0; i < val.length; i++) {
        orderUuid.push(val[i].orderUuid);
        checkupCode.push(val[i].checkupCode);
      }
      this.batch_list = {
        orderUuid: orderUuid,
        checkupCode: checkupCode
      };
    },
    // 获取下载地址
    getDownloadUrl() {
      if (this.batch_list.orderUuid.length < 1) {
        pub.tip('请选择要下载的记录', 'warning');
        return;
      }

      this.download_dis = true;
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const params = {
        page: {number: 0, limit: 10},
        keyWord: [],
        parms: this.batch_list
      };

      ApiService.BulkDownloadReports(params).then(res => {
        this.download_dis = false;
        loading.close();
        if (res.data.type == 'application/json') {
          pub.tip('下载失败,请联系相关人员', 'error');
        } else {
          const date = new Date();
          const day = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          this.downloadFile(res, '报告批量下载' + day + '.zip');

        }

      }).catch(error => {
        this.download_dis = false;
        loading.close();
        this.handleError(error, '批量下载');
      });
    },

    // 显示编辑弹窗
    showEditDiaHandle(val) {
      this.orderForm = {
        strOrderUuid: val.orderUuid,
        projName: val.projectName,
        csrName: val.customerName,
        csrAge: val.customerAge,
        csrGender: val.customerGender,
        checkCode: val.checkCode,
        csrMobile: val.customerMobile
      };
      this.isShowEditDia = true;
    },
    // 编辑之后确定按钮
    updateOrderHandle(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitUpdateOrderHandle();
        } else {
          return false;
        }
      });
    },
    // 提交更新的内容
    submitUpdateOrderHandle() {
      this.updating = true;
      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          orderUuid: this.orderForm.strOrderUuid,      // 订单收单id
          customerName: this.orderForm.csrName,        // 客户姓名
          customerGender: this.orderForm.csrGender,    // 客户性别
          customerMobile: this.orderForm.csrMobile,    // 手机号
          checkCode: this.orderForm.checkCode,         // 识别码
          customerAge: this.orderForm.csrAge,            // 客户年龄
        }

      }
      ApiService.updateHeartOrder(params).then(res => {
        this.isShowEditDia = false;
        if (res.code === pub.backCode.SUCCESS) {
          this.initData();
        } else {
          pub.analysisReturnCode(res, this.submitUpdateOrderHandle);
        }
      }).finally(() => {
        this.updating = false;
      });
    },
    //删除
    delHandle(val) {
      this.$confirm('确定删除订单【' + ' ' + val.customerName + ' (' + val.customerMobile + ')】的信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(() => {
        this.delOrderList(val);
      }).catch(() => {
      });
    },
    //执行删除
    delOrderList(payload) {
      if (this.deleting) return;
      this.deleting = true;
      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          orderUuid: payload.orderUuid,
          checkupCode: payload.checkupCode
        }
      };
      ApiService.delHeartOrder(params).then(res => {
        if (res.code === pub.backCode.SUCCESS) {
          this.current_page = 1;
          this.initData();
        } else {
          pub.analysisReturnCode(res, () => this.delOrderList(payload));
        }
      }).catch(error => {
        if (error == "Error: Request failed with status code 400") {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 2000
          });
        }
      }).finally(() => {
        this.deleting = false;
      });
    },

    exportClick() {
      let order_start = 0;
      let order_end = 0;
      if (this.startTime) {
        order_start = this.startTime / 1000;
      }
      if (this.endTime) {
        order_end = this.endTime / 1000;
      }

      this.export_dis = true;
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          // 时间查询改为数组格式：有值才传，否则为空数组
          timeFrame: (order_start || order_end)
            ? [
              {
                timeType: 5,
                startTime: order_start,
                endTime: order_end,
              }
            ]
            : [],
          projectName: this.proj_name_search,//发送机构名称
          customerName: this.user_name_search,//姓名
          checkupCode: this.exam_code_search,//客户编码
          status: this.dataStatus
        }
      }
      ApiService.ExportHeartOrderData(params).then(res => {
        this.export_dis = false;
        loading.close();
        if (res.data.type == 'application/json') {
          pub.tip('导出失败，请联系相关人员', 'error');
        } else {
          const date = new Date();
          const day = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          this.downloadFile(res, '客户信息列表_' + day + '.zip');
        }

      }).catch(error => {
        this.export_dis = false;
        loading.close();
        this.handleError(error, '导出数据');
      });
    },

    downloadFile(res, filename) {
      const blob = new Blob([res.data], {type: 'application/zip'});
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    showReasonDiaHandle(row){
      this.isShowReasonDia = true;
      this.oprData = [];
      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          orderUuid: row.orderUuid,
          checkupCode:row.checkupCode
        }
      }
      this.oprLoading = true;
      ApiService.BackReason(params).then(res => {
       this.oprLoading = false;
       this.isShowReasonDia = true;
       if (res.code === pub.backCode.SUCCESS) {
          this.oprData = res.data.pageList;
        } else {
          pub.analysisReturnCode(res, () => this.showReasonDiaHandle(row));
        }
      }).catch(error => {
        this.oprLoading = false;
      });
    }

  },
}
</script>

<style scoped lang="scss">
.record-list {
  .filter-content, .dia-load {
    text-align: left;
    padding: 15px 30px;
    background: #ffffff;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
    display: flex;
    align-items: center;
  }

  .time-content {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 460px;
  }

  .time-content .el-col:first-child {
    margin-right: 8px;
  }

  .action-buttons {
    margin-left: auto;
    display: flex;
    gap: 8px;
  }

  .soft-card.table-soft-wrapper {
    text-align: left;
    margin: 0;
    padding: 0;
  }

  .action-btn {
    border: none;
    background: transparent;
    color: #2c9b86;
    padding: 4px 8px;
    font-size: 0.75rem;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s;
    border-radius: 20px;
    height: auto;

    &:hover {
      color: #2b7c6b;
      background: rgba(44, 155, 134, 0.1);
    }
  }

  .action-btn-danger {
    color: #bd6b6b;
    border-radius: 20px;
    transition: all 0.2s;

    &:hover {
      color: #c0392b;
      background: rgba(192, 57, 43, 0.1);
    }
  }

  .action-btn-success {
    color: #2c6bb8;
    border-radius: 20px;
    transition: all 0.2s;

    &:hover {
      color: #2c6bb8;
      background: rgba(44, 107, 184, 0.1);
    }
  }

  .table-soft-wrapper {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .soft-el-table{
    min-height: 500px;
  }

  >>> .line-dialog .el-dialog__body {
    padding-top: 0;
  }

  >>> .el-table .cell {
    .status-btn {
      padding: 4px 14px;
      color: #ffffff;
      text-align: center;
      border-radius: 14px;
      width:fit-content;
      margin: 0 auto;
      font-size: 12px;
      line-height: 1.2;
    }
  }

  >>> .form-dialog .mess {
    line-height: 20px;
    text-align: left;
    padding-left: 12px;
    margin-bottom: 10px;

    span {
      padding-left: 26px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RecordList.vue